import { render, staticRenderFns } from "./TramitesAdministrativosTabContent.vue?vue&type=template&id=624937ac"
import script from "./TramitesAdministrativosTabContent.vue?vue&type=script&lang=js"
export * from "./TramitesAdministrativosTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports